import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const EdificioOpContext = createContext(null);

const STORAGE_KEY = 'op_edificio_id';

export const EdificioOpProvider = ({ children }) => {
  const [edificios, setEdificios] = useState([]);
  const [edificioId, setEdificioIdState] = useState(() => localStorage.getItem(STORAGE_KEY) || '');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/edificios')
      .then(r => {
        const list = r.data || [];
        setEdificios(list);
        // Si no hay seleccionado o el seleccionado no existe, agarrar el primero
        if (list.length && (!edificioId || !list.find(e => e.edificio_id === edificioId))) {
          const first = list[0].edificio_id;
          setEdificioIdState(first);
          localStorage.setItem(STORAGE_KEY, first);
        }
      })
      .catch(() => { /* noop */ })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setEdificioId = (id) => {
    setEdificioIdState(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const edificioActivo = edificios.find(e => e.edificio_id === edificioId) || null;

  return (
    <EdificioOpContext.Provider value={{ edificios, edificioId, setEdificioId, edificioActivo, loading }}>
      {children}
    </EdificioOpContext.Provider>
  );
};

export const useEdificioOp = () => {
  const ctx = useContext(EdificioOpContext);
  if (!ctx) throw new Error('useEdificioOp must be used inside EdificioOpProvider');
  return ctx;
};
